import React from "react";
import { Icon } from "../core/Icon.jsx";

/** Suggested-gift list — name, approximate price, suggested store and a product link. */
export function GiftList({ items = [], currency = "Bs", style }) {
  return (
    <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: "var(--sp-5)", width: "100%", ...style }}>
      {items.map((g, i) => (
        <li key={i} style={{ display: "grid", gap: 6, textAlign: "left", position: "relative", paddingBottom: "var(--sp-5)" }}>
          <span style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 1, background: "linear-gradient(90deg, var(--rule), transparent)" }} />
          <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: "var(--sp-4)" }}>
            <span style={{ fontFamily: "var(--font-title, var(--font-display))", fontSize: "var(--fs-title-s)", letterSpacing: "0.01em", color: "var(--fg-primary)" }}>{g.name}</span>
            {g.price != null && (
              <span style={{ fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body-l)", color: "var(--accent)", whiteSpace: "nowrap" }}>{currency} {g.price}</span>
            )}
          </div>
          {g.description && (
            <span style={{ fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "var(--fs-body)", lineHeight: "var(--lh-snug)", color: "var(--fg-secondary)" }}>{g.description}</span>
          )}
          <div style={{ display: "flex", alignItems: "center", gap: "var(--sp-4)", flexWrap: "wrap", marginTop: 2 }}>
            {g.store && (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: "var(--fs-caption)", color: "var(--fg-muted)" }}>
                <Icon name="store" size={14} /> {g.store}
              </span>
            )}
            {g.url && (
              <a href={g.url} target="_blank" rel="noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontFamily: "var(--font-caps)", fontSize: "var(--fs-micro)", letterSpacing: "var(--ls-wider)", textTransform: "uppercase", color: "var(--accent)" }}>
                Ver producto
              </a>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}
